import './wdyr'; // <--- first import
import React from "react";
import ReactDOM from "react-dom/client";
import { RecoilRoot } from "recoil";
import { Amplify } from 'aws-amplify';
import { Authenticator } from '@aws-amplify/ui-react';
import awsExports from './aws-exports';
import "./index.css";
import EntryPage from "./EntryPage";
import MobileEntryPage from "./MobileEntryPage";
import { BrowserRouter } from "react-router-dom";
import './Assets/Fonts/TitilliumWeb-Regular.ttf';
import './Assets/Fonts/TitilliumWeb-Bold.ttf';

Amplify.configure({
  Auth: {
      region: awsExports.REGION,
      userPoolId: awsExports.USER_POOL_ID,
      userPoolWebClientId: awsExports.USER_POOL_APP_CLIENT_ID
  }
})

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <RecoilRoot>
      <BrowserRouter>
        <Authenticator.Provider>
          {/* <EntryPage /> */}
          <MobileEntryPage />
        </Authenticator.Provider>
      </BrowserRouter>
    </RecoilRoot>
  </React.StrictMode>
);